import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';

type Quick = { text: string; route?: any[]; q?: string };
type Kpi = { label: string; value: number; hint?: string };

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  constructor(private router: Router) {}

  // Prompt state
  prompt = signal('');

  // KPI snapshots (replace with API data)
  kpis: Kpi[] = [
    { label: 'Open appraisals', value: 12, hint: 'Awaiting review' },
    { label: 'Comparables this week', value: 247, hint: 'Sales + Rent' },
    { label: 'Avg. TAT (days)', value: 3, hint: 'Last 30 days' }
  ];

  // Quick suggestions (seed prompt or route)
  quicks: Quick[] = [
    { text: 'Summarize Activity #24-0193', q: 'Summarize valuation for activity 24-0193' },
    { text: 'Find Class A office comps in Austin', q: 'Find Class A office sales comps in Austin last 18 months' },
    { text: 'Variance vs prior appraisal', q: 'Compare latest valuation vs prior; highlight variances' },
    { text: 'Build rent roll from CSV', route: ['/workbench/upload'], q: 'Create rent roll from uploaded CSV' },
  ];

  // Recent work (stub)
  recent = [
    { title: 'As-Is Valuation – 5th Ave Tower', meta: 'Activity 24-0193 • Office • NYC' },
    { title: 'Comps Pack – Austin CBD Offices', meta: 'Sales & Rent • 42 matches' },
    { title: 'Valuation Summary – Lakeside Park', meta: 'Industrial • Dallas–Fort Worth' },
  ];

  // Pipelines (visual steps only)
  pipeline = [
    { name: 'Upload Data', desc: 'CSV / Excel / Argus', to: ['/workbench/upload'] },
    { name: 'Validate', desc: 'Schema & rules', to: ['/data/validate'] },
    { name: 'Run Valuation', desc: 'Scenarios & cap rates', to: ['/valuation/run'] },
    { name: 'Review & Export', desc: 'PDF / Excel / XML', to: ['/valuation/review'] },
  ];

  onSubmit() {
    const q = this.prompt().trim();
    if (!q) return;
    // Route to your AI assistant / search page with the query
    this.router.navigate(['/assistant'], { queryParams: { q } });
  }

  useQuick(item: Quick) {
    if (item.q) this.prompt.set(item.q);
    if (item.route) this.router.navigate(item.route);
  }
}
